<template>
  <div>
    <List
      ref="list"
      url="/api/app/announcement/list"
      :search="params"
      :limit="15"
      :alwaysShowPager="false"
    >
      <template v-slot="{ list }">
        <div
          v-if="list.length > 0"
          class="classes-announcement-list"
          :class="{ 'classes-announcement-list_single': list.length <= 15 }"
        >
          <div class="classes-announcement-item" v-for="item in list" :key="item.id">
            <div class="classes-announcement-time">
              <div class="classes-announcement-date bold6">
                {{ item.created_at | tsFormat('dd') }}
              </div>
              <div class="classes-announcement-year">
                {{ item.created_at | tsFormat('yyyy.MM') }}
              </div>
            </div>
            <div class="classes-announcement-title bold6" @click="onView(item)">
              {{ item.title }}
            </div>
          </div>
        </div>
        <EmptyNew v-else title="暂无公告"></EmptyNew>
      </template>
    </List>
    <el-dialog class="classes-announcement-modal" title="通知详情" :visible.sync="showModal">
      <div class="classes-announcement-modal_title bold5">{{ item.title }}</div>
      <div class="classes-announcement-modal_content">
        <Rich :value="item.content"></Rich>
      </div>
      <template v-slot:footer>
        <el-button type="primary" @click="showModal = false">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import List from '@/components/List.vue';
import EmptyNew from '@/components/EmptyNew.vue';

export default {
  name: 'MemberClassesAnnouncement',
  components: { List, EmptyNew },
  data() {
    return {
      params: {
        class_id: this.$route.params.id,
      },
      showModal: false,
      item: {},
    };
  },
  methods: {
    onView(item) {
      this.item = item;
      this.showModal = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.classes-announcement-list_single {
  padding-bottom: 32px;
}
.classes-announcement-item {
  display: flex;
  align-items: center;
  margin: 0 24px;
  padding: 24px 0;
  border-bottom: 1px solid #e6e6e6;
}
.classes-announcement-time {
  text-align: center;
  margin-right: 24px;
}
.classes-announcement-date {
  font-size: 26px;
  font-family: PingFangSC, PingFangSC-Semibold;
  color: #b99458;
  line-height: 30px;
}
.classes-announcement-year {
  font-size: 13px;
  color: #a17c40;
  line-height: 18px;
}
.classes-announcement-title {
  cursor: pointer;
}
::v-deep {
  .pager {
    padding: 24px 0 !important;
  }
}
.classes-announcement-modal {
  ::v-deep {
    .el-button {
      padding: 10px 19px;
    }
    .el-dialog__headerbtn {
      display: none;
    }
    .el-dialog__header,
    .el-dialog__body,
    .el-dialog__footer {
      padding: 0;
    }
    .el-dialog__footer {
      padding-right: 24px;
    }
    .el-dialog {
      padding: 16px 0 24px 24px;
    }
    .el-textarea__inner {
      height: 160px;
    }
    .el-textarea {
      margin: 16px 0 8px 0;
    }
  }
}
.classes-announcement-modal_title {
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Medium;
  line-height: 22px;
  text-align: center;
  margin: 16px 0 14px 0;
  padding-right: 24px;
}
.classes-announcement-modal_content {
  padding-right: 24px;
  max-height: 424px;
  overflow-y: auto;
  margin: 0 3px 24px 0;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    width: 6px;
    background: #999;
    border-radius: 3px;
  }
}
</style>
